/* eslint-disable max-len */
export default {
    title: 'Kontakt',
    form: {
        title: 'Hinterlassen Sie uns eine Nachricht, wir antworten Ihnen gerne.',
        placeholder: {
            name: 'Vorname',
            surname: 'Nachname',
            email: 'Ihre geschäftliche E-Mail-Adresse',
            phone: 'Ihre Telefonnummer',
            message: 'Ihre Nachricht',
            topic: 'Thema wählen'
        },
        label: {
            checkbox: 'Die Daten werden von Sagiton Sp. z o.o. verwaltet. Sie wurden freiwillig zur Verfügung gestellt und werden vom Verwalter gemäß den Bestimmungen des polnischen Datenschutzgesetzes vom 29. August 1997 (Gesetzblatt von 2002 Nr. 101, Pos. 926, mit spät. Änd.) für Marketingzwecke, Verkauf von Produkten und Dienstleistungen der Sagiton Sp. z o.o. verarbeitet. Ich wurde über das Recht auf Zugang zu meinen Daten, auf ihre Korrektur und über das Recht, jederzeit Einwände gegen ihre Verarbeitung erheben zu können, informiert.',
            checkbox2: 'Ich bin damit einverstanden, mir durch Sagiton Sp. z o.o. kommerzielle Informationen per E-Mail zusenden zu lassen.',
            button: 'Senden',
            refresh: 'Neu Laden',
            showEmail: 'E-Mail anzeigen',
            mailToTitle: 'Kontaktanfrage',
            mailToDisclaimerText: 'Um sicherzustellen, dass Ihre Anfrage nicht als SPAM/BOT-Verkehr betrachtet wird, verwenden Sie bitte die unten stehende E-Mail mit dem Ihnen zugewiesenen eindeutigen Token'
        }
    },
    people: {
        title: 'Warten Sie nicht und schicken Sie uns jetzt eine E-Mail',
        button: 'Chat mit einem Berater',
        labels: {
            mobile: 'mobile',
            mail: 'mail'
        },
        list: [{
            name: 'Jürgen Frücht',
            occupation: 'Business Development Partner',
            phone: '+49 175 689 7058',
            email: 'fruecht@lemlock.de'
        }]
    },
    headquarter: {
        title: 'Adresse',
        address: {
            company: 'Lemlock',
            note: 'Die Marke lemlock ist Eigentum der Sagiton sp. z o.o (LLC)',
            country: 'Polen'
        }
    },
    map: {
        placeId: 'ChIJYcIQWkPPCUcRUpk4bRrJV6E',
        infowindow: {
            navigate_text: 'Anfahrtsbeschreibung',
            navigate_url: 'https://maps.google.com/maps?ll=51.039943,13.729172&z=16&t=m&hl=pl&gl=PL&mapclient=embed&daddr=Lemlock%20-%20Cyber%20Sicherheit%20Bayrische%20Str.%208%2001069%20Dresden%20Niemcy@51.0399432,13.7291719',
            review_text: '',
            review_url: '',
            large_map_text: 'Große Karte'
        }
    }
};



// WEBPACK FOOTER //
// ./src/i18n/de/contact.js